module.exports = __webpack_public_path__ + "static/media/fridge.ba705995.svg";